import { useCallOnceIfTrue } from './useCallOnceIfTrue';

export const useOnFirstMount = (callback: () => void) => {
  useCallOnceIfTrue(callback, true);
};
